import { api } from "@/lib/api";

let anonId = null;
function getAnonId() {
  if (anonId) return anonId;
  try {
    anonId = localStorage.getItem("sc_anon");
    if (!anonId) {
      anonId = "a_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("sc_anon", anonId);
    }
  } catch {
    anonId = "a_" + Math.random().toString(36).slice(2);
  }
  return anonId;
}

// Fire-and-forget presence heartbeat. Used by the tracker and by explicit actions (e.g. applying).
export function pingActivity(activity, role = "") {
  if (!activity) return;
  api.post("/presence/ping", { anon_id: getAnonId(), activity, role }).catch(() => {});
}

// Authenticated per-user page log (owner Control Center "recent pages"). Backend ignores staff.
export function logPage(path) {
  if (!path) return;
  api.post("/activity/page", { path }).catch(() => {});
}
